import { Component, ElementRef, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MatDialogCloseEvent, DocumentType, Role } from '../../../const';
import { AddSchoolComponent } from '../add-school/add-school.component';
import { DtoSchool } from '../../../models/school.model';
import { SchoolService } from '../../school/school.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { SharedService } from '../../../shared/services/shared.service';
import { ConfirmDialogComponent } from '../../mat-account/confirm-dialog/confirm-dialog.component';
import { MatAccountService } from '../../mat-account/mat-account.service';
import { Users } from '../../../models/user-center.model';


@Component({
  selector: 'app-edit-school',
  templateUrl: './edit-school.component.html'
})
export class EditSchoolComponent implements OnInit, OnDestroy {

  schoolData: DtoSchool = {} as DtoSchool;
  isEdit: boolean = false;
  canEditCodes = false;
  @ViewChild('editSchoolFileInput') editSchoolFileInput: ElementRef | undefined;
  schoolAccountUploadFileList: File[] = [];
  maxSize: number = 1 * 1024 * 1024; // 1 MB in bytes
  subscription: Subscription = new Subscription();
  selectedFileCount: number = 0;
  accountAdminList: Users[] = [];
  assignedAccountAdmin: Users = {} as Users;

  schoolForm: FormGroup = new FormGroup({
    id: new FormControl('', [Validators.required]),
    myReferenceSchoolCode: new FormControl('', [Validators.required]),
    schoolId: new FormControl(0),
    assignedAccountAdmin: new FormControl({} as Users),
    schoolName: new FormControl('', [Validators.required, Validators.pattern('^.*[a-zA-Z]+.*$ ?')]),
    location: new FormControl('', [Validators.required, Validators.pattern('^.*[a-zA-Z]+.*$ ?')]),
    numberOfSchoolUser: new FormControl(null as number | null, [Validators.required]),
    schoolCapacity: new FormControl(null as number | null, [Validators.required]),
    headcountOfSchool: new FormControl(null as number | null, [Validators.required]),
    schoolType: new FormControl('', [Validators.required, Validators.pattern('^.*[a-zA-Z]+.*$ ?')]),
    numberOfNonTeachingStaff: new FormControl(null as number | null, [Validators.required]),
    numberOfTeachingStaff: new FormControl(null as number | null, [Validators.required]),
    curriculum: new FormControl('', [Validators.required, Validators.pattern('^.*[a-zA-Z]+.*$ ?')]),
    address: new FormControl('', [Validators.required, Validators.pattern('^.*[a-zA-Z]+.*$ ?')]),
    localAuthority: new FormControl('', [Validators.required, Validators.pattern('^.*[a-zA-Z]+.*$ ?')]),
    schoolRegistrationId: new FormControl('', [Validators.required]),
    notes: new FormControl('')
  });
  constructor( public dialog: MatDialog, private schoolService: SchoolService, 
    @Optional() public dialogRef: MatDialogRef<AddSchoolComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private toasterService: ToastrService,
    private sharedService: SharedService, private matAccountService: MatAccountService ) {}
  
  ngOnInit(): void {
    if(this.data.school.schoolName){
      this.accountAdminList = this.data.accountAdminList;
      this.schoolData = this.data.school;
      this.isEdit = true;
      const userRole = sessionStorage.getItem('user_role')?.split(',')!;
      if (
        userRole?.includes(Role.SuperAdmin) ||
        userRole?.includes(Role.AccountAdmin)
      ){
        this.canEditCodes = true;
      }
      
      this.patchSchool(this.schoolData);
    }
    this.subscription.add(this.sharedService.doFileUpload.subscribe((data) => {
      if(data){
        this.uploadFromLocal(data, true);
      }
    }));
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  patchSchool(data: DtoSchool){
    this.assignedAccountAdmin = this.accountAdminList.find(x => x.userId == data.assignedAccountAdmin)!;
    this.schoolForm.patchValue({
      schoolId: data.schoolId,
      id: data.id,
      myReferenceSchoolCode:data.myReferenceSchoolCode,
      assignedAccountAdmin: this.assignedAccountAdmin,
      schoolName: data.schoolName,
      location: data.location,
      numberOfSchoolUser: data.numberOfSchoolUser,
      schoolCapacity: data.schoolCapacity,
      headcountOfSchool: data.headcountOfSchool,
      schoolType: data.schoolType,
      numberOfNonTeachingStaff: data.numberOfNonTeachingStaff,
      numberOfTeachingStaff: data.numberOfTeachingStaff,
      curriculum: data.curriculum,
      address: data.address,
      localAuthority: data.localAuthority,
      schoolRegistrationId: data.schoolRegistrationId,
      notes: data.notes
    });
  }
  cancel(){
    this.dialogRef.close({event: MatDialogCloseEvent.CANCELLED});
  }

  updateSchool(){

    const SchoolAccountformData = new FormData();
    this.schoolAccountUploadFileList.forEach((file: File) => {
      SchoolAccountformData.append('file', file, file.name);
    });
    let schoolDetails = this.schoolForm.value;

    if(schoolDetails.myReferenceSchoolCode!=this.schoolData.myReferenceSchoolCode){
      if(!confirm(`Are you sure you want to change the School Reference from ${this.schoolData.myReferenceSchoolCode} to ${schoolDetails.myReferenceSchoolCode}?`)){
        return;
      }
    }

    schoolDetails.assignedAccountAdmin = schoolDetails.assignedAccountAdmin?.userId;
    this.schoolService.updateSchool([schoolDetails]).subscribe((res)=>{
      if(res){
        this.toasterService.success("School Updated Successfully","Success");
        if(this.schoolAccountUploadFileList.length){
          this.uploadDocument(SchoolAccountformData, DocumentType.School, this.schoolData.entityId!.toString());
        }
        this.dialogRef.close({event: MatDialogCloseEvent.SUCCESS});
      }
    },(error: HttpErrorResponse)=>{
      if(error.error){
        this.toasterService.error(error.error, "Error");
      }
    })
  }

  uploadDocument(formData: FormData, documentTypeId: string, referenceId: string) {
    this.matAccountService.uploadDocument(formData, documentTypeId, referenceId).subscribe(
      (res: any) => {
        if (res) {
          console.log("Uploaded Successfully");
        }
      },
      (error: HttpErrorResponse) => {
        if(error.error){
          this.toasterService.error(error.error, "Error");
        }
      }
    );
  }

  uploadFromLocal(event: Event, triggeredManually = false): void {
    if (!triggeredManually) {
      event.preventDefault();
      this.sharedService.setUploadedFile(this.schoolAccountUploadFileList);
      this.dialog.open(ConfirmDialogComponent, { width: '675px', data: {
        hideUpload: false,
        isParentUpload: true
      }}).afterClosed().subscribe(() => {
        this.selectedFileCount = this.schoolAccountUploadFileList.length;
      });
    }
    if (this.editSchoolFileInput) {
      this.editSchoolFileInput.nativeElement.click();
    }
  }

  onFileSelected(event: any) {
    if (!this.schoolAccountUploadFileList) {
      this.schoolAccountUploadFileList = [];
    }

    let filesExist = event.target.files.length;
    if (filesExist > 0) {
      for (let i = 0; i < filesExist; i++) {
        if (event.target.files && event.target.files[i]) {
          if(event.target.files[i].size <= this.maxSize){
            let _object: File = event.target.files[i];

            this.schoolAccountUploadFileList.push(_object);
          }
          else{
            this.toasterService.warning('File size must be less than 1 MB.');
          }
        }
      }
      this.sharedService.changeUploadingStatus(false);
      this.sharedService.setUploadedFile(this.schoolAccountUploadFileList);
      this.selectedFileCount = this.schoolAccountUploadFileList.length;
      this.editSchoolFileInput!.nativeElement.value = null;
    }
  }
}
